// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".test-plans__title[data-v-22891a7c]{max-width:420px}@media(min-width:0)and (max-width:767px){.test-plans__title[data-v-22891a7c]{max-width:100%}}.test-plans__complete-tag[data-v-22891a7c]{position:absolute;top:40px;left:16px;border-radius:4px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
